/* HTTP Documents repository — multipart upload to the backend (→ MinIO). */
import { apiDelete, apiGet, apiUpload } from './httpClient'
import type { Document } from './types'
import type { AddDocumentInput } from './documents.mock'

export function listDocuments(tripId: string, pointId?: string): Promise<Document[]> {
  const q = pointId ? `?point_id=${pointId}` : ''
  return apiGet<Document[]>(`/trips/${tripId}/documents${q}`)
}

export function addDocument(tripId: string, input: AddDocumentInput): Promise<Document> {
  const form = new FormData()
  form.append('file', input.file)
  if (input.point_id) form.append('point_id', input.point_id)
  if (input.type) form.append('type', input.type)
  if (input.visibility) form.append('visibility', input.visibility)
  if (input.client_id) form.append('client_id', input.client_id)
  return apiUpload<Document>(`/trips/${tripId}/documents`, form)
}

export function deleteDocument(tripId: string, documentId: string): Promise<void> {
  return apiDelete(`/trips/${tripId}/documents/${documentId}`)
}
